import { render, staticRenderFns } from "./TServHouseFilterComp.vue?vue&type=template&id=119b8f60&"
import script from "./TServHouseFilterComp.vue?vue&type=script&lang=js&"
export * from "./TServHouseFilterComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports